import React from "react";
import "./InternalProjectLinks.css";

function InternalProjectLinks() {
  const links = [
    {
      name: "CRM",
      url: "https://crm.trackhr.co.in/Login/",
      description: "Customer Relationship Management",
    },
    {
      name: "ACL",
      url: "https://acl.trackhr.co.in/Login/",
      description: "Access Control & Licensing",
    },
    {
      name: "HPM",
      url: "https://hpm.trackhr.co.in/Login/",
      description: "Human Process Management",
    },
  ];

  return (
    <div className="page">
      <div className="card">
        <h1>Internal Project Portals</h1>
        <p className="subtitle">Quick access to internal applications</p>

        {links.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="project"
          >
            <div className="badge">{item.name}</div>
            <div className="info">
              <div className="title">{item.name}</div>
              <div className="desc">{item.description}</div>
            </div>
            <div className="arrow">→</div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default InternalProjectLinks;
